import '../styles.scss'
import React from 'react'

import { Selector, Timer } from 'components/SmartChatView/Fields'

const TimeOutViewUI = ({ renderType, withPetition, withProcess, label, placeholder, timerPetitionsOptions, processesOptions, value, onChangeInner, loadingProcessesOptions, error, previewIntegrity }) => (
  <div className='action-view'>
    {renderType === 'action' && (
      <>
        {withPetition && (
          <Selector
            isRequired
            label={label.petition}
            placeholder={placeholder.petition}
            options={timerPetitionsOptions}
            value={value.petition}
            onChange={value => onChangeInner({ fieldType: 'petition', fieldData: value })}
            error={error?.petition}
          />
        )}
        {((withPetition && value.petition) || withProcess) && (
          <Timer
            isRequired
            label={label.timer}
            value={value.timer}
            onChange={value => onChangeInner({ fieldType: 'timer', fieldData: value })}
            error={error?.timer}
          />
        )}
        {withProcess && value.timer?.time > 0 && (
          <Selector
            isRequired
            label={label.process}
            placeholder={placeholder.process}
            options={processesOptions || []}
            value={value.process}
            onChange={value => onChangeInner({ fieldType: 'process', fieldData: value })}
            loading={loadingProcessesOptions}
            error={error?.process}
          />
        )}
      </>
    )}
    {renderType === 'preview' && (
      <div className='action-view__timeout-preview'>
        {withPetition && (
          <Selector
            placeholder={placeholder.petition}
            options={timerPetitionsOptions}
            value={value.petition}
            onChange={value => onChangeInner({ fieldType: 'petition', fieldData: value })}
            error={previewIntegrity.petition}
          />
        )}
        <Timer
          value={value.timer}
          onChange={value => onChangeInner({ fieldType: 'timer', fieldData: value })}
          error={previewIntegrity.timer}
        />
        {withProcess && (
          <Selector
            placeholder={placeholder.process}
            options={processesOptions || []}
            value={value.process}
            onChange={value => onChangeInner({ fieldType: 'process', fieldData: value })}
            loading={loadingProcessesOptions}
            error={previewIntegrity.process}
          />
        )}
      </div>
    )}
  </div>
)

export default TimeOutViewUI
